import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"
import { Region, FilterValue } from "@/shared/types/type/search"

interface SearchUiStore {
  isSearchBarFocused: boolean
  setIsSearchBarFocused: (isSearchBarFocused: boolean) => void
  keyword: string
  setKeyword: (keyword: string) => void,
  regionList: Region[]
  setRegionList: (regionList: Region[]) => void
  selectedRegion: number
  setSelectedRegion: (selectedRegion: number) => void
  selectedSubRegions: FilterValue[]
  setSelectedSubRegions: (selectedSubRegions: FilterValue[]) => void
  resetSearchAll: () => void
}

export const useSearchUiStore = create<SearchUiStore>((set) => ({
  isSearchBarFocused: false,
  setIsSearchBarFocused: (isSearchBarFocused) => set({ isSearchBarFocused }),
  keyword: "",
  setKeyword: (keyword: string) => set({ keyword }),
  regionList: [] as Region[],
  setRegionList: (regionList: Region[]) => set({ regionList: regionList }),
  selectedRegion: 1,
  setSelectedRegion: (selectedRegion: number) => set({ selectedRegion }),
  selectedSubRegions: [] as FilterValue[],
  setSelectedSubRegions: (selectedSubRegions: FilterValue[]) => set({ selectedSubRegions }),
  resetSearchAll: () => set({
    keyword: "",
    selectedRegion: 1,
    selectedSubRegions: [],
  }),
}))

interface SearchUiPersistStore {
  recentSearchKeywordList: string[]
  setRecentSearchKeywordList: (recentSearchKeywordList: string[]) => void
  recentClear: () => void
}

export const useSearchUiPersistStore = create<SearchUiPersistStore>()(persist((set) => {
  return {
    recentSearchKeywordList: [],
    setRecentSearchKeywordList: (recentSearchKeywordList: string[]) => set({ recentSearchKeywordList }),
    recentClear: () => set({ recentSearchKeywordList: [] }),
  }
}, {
  name: "RECENT_SEARCH_KEYWORD",
  storage: createJSONStorage(() => localStorage),
  skipHydration: true,
}))